import axios from 'axios'

axios.defaults.xsrfCookieName = '__RequestVerificationToken'

export default {
  get(url, request) {
    return axios
      .get(url, request)
      .then(({data}) => data)
  },
  post(url, data, config) {
    return axios.post(url, data, config)
  },
  patch(url, request, config) {
    return axios.patch(url, request, config)
  },
  put(url, data, config) {
    return axios.put(url, data, config)
  },
  delete(url, request) {
    return axios.delete(url, request)
  }
}